module.exports = __webpack_public_path__ + "media/psychotype.013cf71a.mp4";